module.exports = __webpack_public_path__ + "img/display_student_bg.1f68cbbe.png";